export class PauseEvent {
    constructor() {
        this.type = "pause";
    }
    static getType() {
        return "pause";
    }
}
